import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Card,
  CardContent,
  IconButton,
} from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const RolePermissions = () => {
  const [roles, setRoles] = useState([]);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // Fetch roles on mount
  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/getRoles`).then((response) => {
      setRoles(response.data);
    });
  }, []);

  // Handle navigation to the Edit Role component
  const handleEdit = (role) => {
    navigate(`/admin-user/edit-role/${role.id}`); // Pass the role ID as a URL parameter
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 6 }}>
       <Card sx={{ borderRadius: 2, boxShadow: 3 }}>
      <CardContent>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: '#3f51b5' }}>
          Role Permissions
        </Typography>
        <TableContainer >
          <Table sx={{ minWidth: 650 }} aria-label="roles table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.6)' }}>Role ID</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.6)' }}>Role Name</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.6)' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {roles.map((role) => (
                <TableRow key={role.id} sx={{ '&:hover': { backgroundColor: '#f5f5f5' }, transition: 'all 0.3s ease' }}>
                  <TableCell>{role.id}</TableCell>
                  <TableCell>{role.name}</TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      color="primary"
                      sx={{
                        borderRadius: 1,
                        '&:hover': {
                          backgroundColor: '#1976d2',
                          boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                        },
                      }}
                      onClick={() => handleEdit(role)}
                    >
                      Edit
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
    </Container>
  );
};

export default RolePermissions;
